import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

import { defineNuxtPlugin } from 'nuxt/app'

// Register the dayjs `relativeTime` plugin at app boot, before any component in
// this layer renders (SSR + client). The conversation list falls back to
// `messageDate.fromNow(true)`; relying on a top-level `extend()` side-effect
// inside a util module let bundlers tree-shake/reorder it, so a lazy-loaded
// call site could run first and throw `TypeError: x.fromNow is not a function`
// (Sentry CLIENTPORTAL-NUXT-7).
//
// Scoped to this layer on purpose: only apps that extend chats-layer load it,
// so apps like meet (which do not) never pay for a plugin they don't use.
dayjs.extend(relativeTime)

export default defineNuxtPlugin(() => {})
